export const ISO_FULL_DATE_FORMAT   = 'YYYY-MM-DDTHH:mm:ss[Z]';
export const ISO_DATE_INPUT         = 'YYYY-MM-DDTHH:mm:ss';
export const TIME_ONLY              = 'LT';
export const FULL_LOCALE_DATE       = 'L LTS';
export const DATE_PATTERN           = 'L';
export const MONTH_YEAR_FORMAT      = 'MM/YYYY';
export const DEFAULT_DATE_PATTERN   = 'YYYY-MM-DD';
export const MONTH_YEAR_PATTERN     = 'YYYY-MM';
export const YEAR_PATTERN           = 'YYYY';